import { createSlice } from '@reduxjs/toolkit';
import {
  fetchClientPortfolioPhotos,
  fetchPortfolioPhotos,
  deletePortfolioPhoto,
  updatePortfolioPhotoSequence,
} from '../thunks/portfolio';

const initialState = {
  clientPortfolioPhotos: [],
  portfolioPhotos: [],
  pageNumber: 1,
  perPage: 80,
  fetching: false,
  fetchError: '',
  saving: false,
  saveError: '',
};

export const portfolioSlice = createSlice({
  name: 'portfolio',
  initialState,
  reducers: {},
  extraReducers: {
    [fetchClientPortfolioPhotos.pending]: (state) => {
      state.fetching = true;
    },
    [fetchClientPortfolioPhotos.fulfilled]: (state, action) => {
      state.clientPortfolioPhotos = action.payload;
    },
    [fetchClientPortfolioPhotos.rejected]: (state, action) => {
      state.fetching = false;
      state.fetchError = action.payload;
    },
    [fetchPortfolioPhotos.pending]: (state) => {
      state.fetching = true;
    },
    [fetchPortfolioPhotos.fulfilled]: (state, action) => {
      state.fetching = false;
      state.portfolioPhotos = action.payload;
    },
    [fetchPortfolioPhotos.rejected]: (state, action) => {
      state.fetching = false;
      state.fetchError = action.payload;
    },
    [deletePortfolioPhoto.pending]: (state) => {
      state.saving = true;
    },
    [deletePortfolioPhoto.fulfilled]: (state, action) => {
      state.saving = false;
      state.portfolioPhotos = state.portfolioPhotos.filter(
        (photo) => photo.id !== action.payload
      );
    },
    [deletePortfolioPhoto.rejected]: (state, action) => {
      state.saving = false;
      state.saveError = action.payload.error;
    },
    [updatePortfolioPhotoSequence.pending]: (state) => {
      state.saving = true;
    },
    [updatePortfolioPhotoSequence.fulfilled]: (state, action) => {
      state.saving = false;
    },
    [updatePortfolioPhotoSequence.rejected]: (state, action) => {
      state.saving = false;
      state.saveError = action.payload.error;
    },
  },
});
